/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileNewsletterListContactsResponse } from '../../models/profile-newsletter-list-contacts-response';

export interface ProfileNewsletterListContact$Params {
  id: number;

/**
 * Default value is 0
 */
  page?: number;

/**
 * Default value is 10
 */
  pageSize?: number;

/**
 * Default value is by 'ID' (e.g. date of creation). Possible values are 'email', 'firstName' or 'lastName'.
 */
  sort?: string;

/**
 * Default value is 'asc'. Other possible value is 'desc'.
 */
  sortOrder?: string;

/**
 * Fulltext search.
 */
  search?: string;
}

export function profileNewsletterListContact(http: HttpClient, rootUrl: string, params: ProfileNewsletterListContact$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileNewsletterListContactsResponse>> {
  const rb = new RequestBuilder(rootUrl, profileNewsletterListContact.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('sort', params.sort, {});
    rb.query('sortOrder', params.sortOrder, {});
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileNewsletterListContactsResponse>;
    })
  );
}

profileNewsletterListContact.PATH = '/rest/profile/{id}/newsletter/contact';
